import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import * as yup from "yup";
import BasicInformation from "./BasicInformation";
import { SignUpAPI, WarehousesAPI, WeighmentIndicatorsAPI } from "api";
import { customSettings, LOCAL_STORAGE_USER } from "utils/customConfig";
import { toast } from "react-toastify";
import PageTitle from "utils/PageTitle";
import BreadCrumbTable from "components/breadcrumb/BreadCrumbTable";

const schema = yup
  .object({
    name: yup.string().required("This field is required"),
    pickupContact: yup
      .string()
      .required("Contact is required")
      .matches(/^(?:\+92|0)?3\d{9}$/, "Enter a valid Pakistan mobile number"),
    // .string().required("This field is required"),
    pickupPhoneNumber: yup
      .string()
      .required("Contact is required")
      .matches(/^(?:\+92|0)?3\d{9}$/, "Enter a valid Pakistan mobile number"),
    pickupAddress: yup.string().required("This field is required"),
    pickupCity: yup.string().required("This field is required"),
    pickupState: yup.string().required("This field is required"),
    pickupPostalCode: yup.string().required("This field is required"),
    pickupCountry: yup.string().required("This field is required"),
    returnContact: yup.string().required("This field is required"),
    returnPhoneNumber: yup.string().required("This field is required"),
    returnAddress: yup.string().required("This field is required"),
    returnCity: yup.string().required("This field is required"),
    returnState: yup.string().required("This field is required"),
    returnPostalCode: yup.string().required("This field is required"),
    returnCountry: yup.string().required("This field is required"),
    status: yup.boolean(),
  })
  .required();

const AddWarehouse = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const submittedValues = {};
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {},
  });
  const { handleSubmit, reset, setValue } = methods;

  let user = JSON.parse(localStorage.getItem("user"));

  const onSubmit = async (data) => {
    let myData = {
      ...data,
      id: location?.state?.id ?? 0, // Use nullish coalescing to handle undefined or null
      sellerId: LOCAL_STORAGE_USER?.id,
    };

    console.log(myData);

    try {
      if (location?.state) {
        setLoading(true);
        await WarehousesAPI.post(myData);
        setLoading(false);
        toast.success("Warehouse updated successfully", {
          position: customSettings.toastPosition,
          autoClose: customSettings.toastClose,
        });
      } else {
        setLoading(true);
        await WarehousesAPI.post(myData);
        setLoading(false);
        toast.success("Warehouse created successfully", {
          position: customSettings.toastPosition,
          autoClose: customSettings.toastClose,
        });
      }

      // ------- Get all object keys form data and set empty values to reset ------------
      const keys = Object.keys(data);
      for (const key of keys) {
        submittedValues[key] = "";
      }
      reset({ ...submittedValues });
      navigate(-1);
    } catch (error) {
      toast.error("Something went wrong", {
        position: customSettings.toastPosition,
        autoClose: customSettings.toastClose,
      });
      console.log(error);
    }
  };

  useEffect(() => {
    if (location?.state) {
      reset(location.state);
    }
  }, [setValue]);

  return (
    <>
      <PageTitle name="Sellers | Warehouses" />
      {/* <div className="py-2">
        <BreadCrumb />
      </div> */}
      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onSubmit)} noValidate>
          <Card>
            <Card.Header className="border-bottom">
              <Row className="flex-between-center ">
                <Col md>
                  <BreadCrumbTable
                    title={LOCAL_STORAGE_USER?.name || "Sellers"}
                    subTitle="Warehouses"
                    subSubTitle={location?.state?.name}
                  />
                  {/* <h5 className="fs-9 text-nowrap mb-2 mb-md-0">
                    {" "}
                    Libraries | Weighment Indicators
                  </h5> */}
                </Col>
                <Col xs="auto">
                  <Button
                    variant="link"
                    className="text-secondary fw-medium p-0 me-3"
                    type="button"
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </Button>
                  <Button variant="primary" type="submit" disabled={loading}>
                    Ok
                  </Button>
                </Col>
              </Row>
            </Card.Header>
            <BasicInformation />
          </Card>
        </Form>
      </FormProvider>
    </>
  );
};

export default AddWarehouse;
